var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlanning = function SvgPlanning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M61.4 24.8H26.6v-16l6-1.5a46.8 46.8 0 0 1 22.7 0L61.4 9v15.8ZM32.1 13v6.2h23.8V13l-1.9-.4a41.3 41.3 0 0 0-20 0l-2 .4Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M23 12H8.1v67.5L23.6 81a186 186 0 0 0 41 0l15.2-1.6V11.9H65.2v5.5h9.2v57.1L64 75.7a180.6 180.6 0 0 1-39.8 0l-10.4-1.2v-57H23v-5.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M43.7 67.6 28.1 47.1l4.4-3.6 10.7 14.1 15.6-25.9 4.8 3-19.9 33Z"
  })));
};
export default SvgPlanning;